/** Formatting for the user's display name shown in the navbar user menu. */

/**
 * Capitalize the first letter of each whitespace-separated word, preserving the rest of each word
 * (so "McDonald" stays "McDonald", not "Mcdonald"). Collapses runs of whitespace to single spaces.
 */
export function titleCaseWords(value: string): string {
  return value
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

/**
 * The name to show for a user: their display name (title-cased) when it's valid (non-blank),
 * otherwise their email as a fallback. Email is returned as-is (never title-cased).
 */
export function formatDisplayName(
  user?: { display_name?: string | null; email?: string | null } | null,
): string {
  if (!user) return "";
  const displayName = (user.display_name ?? "").trim();
  if (displayName) return titleCaseWords(displayName);
  return user.email ?? "";
}
